import React, { FC } from 'react'
import { SERVICES_AND_BENEFITS, CONTACT_US_COPY } from './helpers/constants'
import { handleClick } from './helpers'
import ValuePropTwoColumn from 'components/SA/ValuePropTwoColumn'
import styles from './ArtAdvisory.module.scss'

const Component: FC = () => {
  const { image, items, title } = SERVICES_AND_BENEFITS
  return (
    <ValuePropTwoColumn image={image} imagePosition='left'>
      <>
        <h3 className={`${styles.servicesTitle} defaultTypographyH3`}>{title}</h3>
        <div className={styles.listContainer}>
          {items.map((item, index) => {
            const { subhead, description } = item
            return (
              <div className={styles.item} key={index}>
                <p className={`${styles.itemTitle} defaultTypographyCtaLarge defaultTextUppercase`}>
                  {subhead}
                </p>
                <p className={`${styles.itemDescription} defaultTypographyMedium`}>{description}</p>
              </div>
            )
          })}
        </div>
        <button
          type='button'
          className={`${styles.servicesButton} defaultButtonOutlined`}
          onClick={handleClick}
        >
          <p className={`${styles.buttonText} defaultTypographyCtaLarge defaultTextUppercase`}>
            {CONTACT_US_COPY}
          </p>
        </button>
      </>
    </ValuePropTwoColumn>
  )
}

export default Component
